export default __webpack_public_path__ + "1cd150653feec8fb968e2a145a818162.png";